import { QuotePostRequestBody, QuotePostResponse } from '@lio/api-types';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateQuote = () => {
  const client = useClient();
  const mutationFn = ({
    customerId,
    productOptionId,
    brokerageId,
    brokerageProducerId,
    effectiveOn,
    expiresOn,
    insuranceLineBundleId,
    insuredLocationIds,
    offeringId,
    writingCompanyId,
    productLabelId,
    createdWithQuoteSetupPresetId,
    bindWithRenewalTerm,
    policyNumber,
    formsV2Enabled,
  }: QuotePostRequestBody) =>
    client
      .post('quote', {
        json: {
          customerId,
          productOptionId,
          productLabelId,
          brokerageId,
          brokerageProducerId,
          effectiveOn,
          expiresOn,
          insuranceLineBundleId,
          insuredLocationIds,
          offeringId,
          writingCompanyId,
          createdWithQuoteSetupPresetId,
          bindWithRenewalTerm,
          policyNumber,
          formsV2Enabled,
        },
      })
      .json<QuotePostResponse>();
  const result = useMutation({ mutationFn });
  return { ...result, createQuoteAsync: result.mutateAsync };
};
